import React from 'react';
import MobileMatchList from './MobileMatchList';

/**
 * 比赛列表组件
 * 为了简化，重用移动端组件
 * 
 * @returns {JSX.Element} 比赛列表组件
 */
const MatchList = () => {
  return <MobileMatchList />;
};

export default MatchList; 